import { MarketplaceSolutionsSectionDataFilters } from '@models/section/marketplaceSolutionsSection';

const filterMapper: Record<string, string> = {
    region: 'localRegionId',
    category: 'filterParameter=1&filterSlug',
    industry: 'filterParameter=3&filterSlug',
    solutionTiers: 'solutionTiers',
    sortBy: 'sortBy',
} satisfies Record<keyof MarketplaceSolutionsSectionDataFilters, string>;

export const getQueryStringFromFilters = (filters?: MarketplaceSolutionsSectionDataFilters): string => {
    if (!filters) return '';
    let queryString = '';
    for (const [key, value] of Object.entries(filters)) {
        if (value) {
            if (Array.isArray(value)) {
                if (value.length) {
                    queryString += `${filterMapper[key]}=${value.toString()};`;
                }
            } else {
                queryString += `${filterMapper[key]}=${value}&`;
            }
        }
    }
    return queryString ? queryString.slice(0, -1) : '';
};
